import React, { useState } from "react";
import DashboardMainContainer from "../common/Containers/DashboardMainContainer";
import {
  AdminMetric,
  AdminSupportingText,
  AdminFilterChipButton,
} from "../../sections/AdminDashboard/shared/adminUx";
import { AdminWidgetHeader, AdminWidgetPeriodFilter } from "./AdminWidgetChrome";

const ReviewsTagsWidget = () => {
  const [timeFilterPeriod, setTimeFilterPeriod] = useState("30 Days");

  const tagsData = {
    totalTags: 66,
    tags: [
      { name: "Plumbing", count: 14 },
      { name: "Friendly", count: 11 },
      { name: "Fast Service", count: 9 },
      { name: "Professional", count: 8 },
      { name: "Emergency", count: 7 },
      { name: "Clean", count: 6 },
      { name: "Affordable", count: 4 },
      { name: "Reliable", count: 3 },
      { name: "Expert", count: 2 },
      { name: "Quality", count: 1 },
      { name: "Trusted", count: 1 },
    ],
  };

  return (
    <DashboardMainContainer className="masonry-item w-[500px] h-[400px] flex flex-col">
      <AdminWidgetHeader title="Reviews Tag">
        <AdminWidgetPeriodFilter
          period={timeFilterPeriod}
          onPeriodChange={setTimeFilterPeriod}
        />
      </AdminWidgetHeader>
      <div className="flex-1 p-4">
        <div className="mb-4">
          <AdminMetric size="large" className="text-offblack block">
            {tagsData.totalTags}
          </AdminMetric>
          <AdminSupportingText className="text-offblack block">Total tags</AdminSupportingText>
        </div>
        <div className="flex flex-wrap gap-2 mt-5">
          {tagsData.tags.map((tag) => (
            <AdminFilterChipButton
              key={tag.name}
              type="button"
              className="!bg-primaryblue !text-white !border-primaryblue hover:!border-primaryblue"
            >
              {tag.name} {tag.count}
            </AdminFilterChipButton>
          ))}
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default ReviewsTagsWidget;
